(function () {
  const BUTTON_ID = 'depo-add-to-cart';
  console.log('[formSubmit] Initializing simplified form validation');

  function getSelectedVariantId() {
    const input = document.querySelector(
      'form[data-type="add-to-cart-form"] input[name="id"]'
    );
    return input && input.value ? String(input.value) : '';
  }

  function getCurrentProductVariantIds() {
    const fromMeta = window.ShopifyAnalytics?.meta?.product?.variants;
    if (fromMeta && fromMeta.length) {
      return fromMeta.map(variant => String(variant.id));
    }
    const script = document.querySelector(
      'variant-radios script[type="application/json"], variant-selects script[type="application/json"]'
    );
    if (script) {
      try {
        return JSON.parse(script.textContent).map(variant => String(variant.id));
      } catch (e) {
        return [];
      }
    }
    return [];
  }

  // Depo reads ?variant= once at init, then always posts that id (or variants[0]).
  // When the first route is sold out, Book Now 422s even if another route is selected.
  function rewriteCartAddItems(items) {
    const selected = getSelectedVariantId();
    if (!selected || !Array.isArray(items)) return false;
    const siblings = getCurrentProductVariantIds();
    let changed = false;
    items.forEach(item => {
      if (item == null || item.id == null) return;
      const postedId = String(item.id);
      if (siblings.length && siblings.indexOf(postedId) === -1) return;
      if (postedId !== selected) {
        item.id = /^\d+$/.test(selected) ? Number(selected) : selected;
        changed = true;
      }
    });
    return changed;
  }

  function rewriteCartAddBody(body) {
    if (!body || typeof body !== 'string') return body;
    try {
      const json = JSON.parse(body);
      if (json.items && rewriteCartAddItems(json.items)) {
        return JSON.stringify(json);
      }
    } catch (e) {
      /* form-encoded or non-JSON body */
    }
    return body;
  }

  if (!window.__bamDepoVariantFix) {
    window.__bamDepoVariantFix = true;
    const originalFetch = window.fetch;
    window.fetch = function (input, init) {
      const url = typeof input === 'string' ? input : input && input.url;
      if (url && String(url).indexOf('/cart/add') !== -1 && init && init.body) {
        init = Object.assign({}, init, { body: rewriteCartAddBody(init.body) });
      }
      return originalFetch.call(this, input, init);
    };
  }

  // Function to update URL with selected values
  function updateURL(location, time, names, quantity, seatingPreference) {
    const url = new URL(window.location.href);
    if (location) url.searchParams.set('location', location);
    if (time) url.searchParams.set('time', time);
    if (names && names.length > 0)
      url.searchParams.set('names', names.join(','));
    if (quantity) url.searchParams.set('quantity', quantity);
    if (seatingPreference) url.searchParams.set('seating', seatingPreference);
    const variantId = getSelectedVariantId();
    if (variantId) url.searchParams.set('variant', variantId);
    const nextUrl = url.toString();
    if (nextUrl === window.location.href) return;
    // Replace the current product entry. pushState stacked a new entry on
    // every init and field sync, so Back had to be pressed several times.
    history.replaceState({}, '', nextUrl);
  }

  // Function to validate form
  function validateForm() {
    // ------------------------------------------------------------------
    // Partial-payment mode: customer entered a validated original order #.
    // Only require their own name (+ confirmed order number).  Boarding
    // and seating fields are hidden/disabled and should not be validated.
    // ------------------------------------------------------------------
    const orderInput = document.getElementById('original-order-number');
    const isPartialPayment = orderInput && orderInput.dataset.orderValid === 'true';

    if (isPartialPayment) {
      const travelersWrapper = document.getElementById('travelers-wrapper');
      const travelerInputs = travelersWrapper?.querySelectorAll(
        '.traveler-group input[type="text"]'
      );
      const hasValidTravelers =
        travelerInputs &&
        Array.from(travelerInputs).every(input => input.value.trim() !== '');
      const hasOrderNumber = orderInput.value.trim() !== '';
      return hasOrderNumber && hasValidTravelers;
    }

    // ------------------------------------------------------------------
    // Standard booking mode
    // ------------------------------------------------------------------
    const elements = {
      customQtyInput: document.getElementById('CustomQuantityProperty'),
      travelersWrapper: document.getElementById('travelers-wrapper'),
      boardingLocation: document.querySelector('#boarding_location'),
      boardingTime: document.querySelector('#boarding_time'),
      seatingPreference: document.querySelector('#seating_preference')
    };

    // Validate required fields
    const hasLocation = elements.boardingLocation?.value?.trim() !== '';
    const hasTime = elements.boardingTime?.value?.trim() !== '';
    const hasSeatingPreference =
      elements.seatingPreference?.value?.trim() !== '';

    // Validate quantity and travelers
    const quantity = parseInt(elements.customQtyInput?.value) || 0;
    const hasValidQuantity = quantity > 0;

    const travelerInputs = elements.travelersWrapper?.querySelectorAll(
      '.traveler-group input[type="text"]'
    );
    const hasValidTravelers =
      travelerInputs &&
      Array.from(travelerInputs).every(input => input.value.trim() !== '');

    const isValid =
      hasValidQuantity &&
      hasValidTravelers &&
      hasLocation &&
      hasTime &&
      hasSeatingPreference;

    // Debug logging
    // console.log('[validateForm] Validation check:', {
    //   hasValidQuantity,
    //   hasValidTravelers,
    //   hasLocation,
    //   hasTime,
    //   hasSeatingPreference,
    //   isValid,
    //   values: {
    //     quantity: elements.customQtyInput?.value,
    //     location: elements.boardingLocation?.value,
    //     time: elements.boardingTime?.value,
    //     seating: elements.seatingPreference?.value,
    //     travelers: Array.from(travelerInputs || []).map(input => input.value)
    //   }
    // });

    return isValid;
  }

  // Function to show error message
  function showErrorMessage() {
    // Remove previous warnings
    document.querySelectorAll('.form-warning').forEach(el => el.remove());

    // Add warning message
    const warningDiv = document.createElement('div');
    warningDiv.className = 'form-warning';
    warningDiv.style.cssText =
      'margin: 10px 0; padding: 10px; border: 1px solid #d20000; border-radius: 4px; background-color: #ffe6e6;';
    warningDiv.innerHTML = 'Please fill in all required fields before booking';

    // Insert warning before the button (try Depo button first, then fallback to buttons container)
    const button = findDepoButton();
    if (button && button.parentNode) {
      button.parentNode.insertBefore(warningDiv, button);
    } else {
      const buttonsContainer = document.querySelector('.product-form__buttons.flex-column, #product-form-buttons');
      if (buttonsContainer) {
        buttonsContainer.insertBefore(warningDiv, buttonsContainer.firstChild);
      }
    }
  }

  // Function to hide error message
  function hideErrorMessage() {
    document.querySelectorAll('.form-warning').forEach(el => el.remove());
  }

  // Function to update deposit text in Depo elements
  function updateDepositText() {
    // console.log('[debug-depo-text] Starting deposit text update...');

    // Look for various possible selectors where the deposit text might appear
    const selectors = [
      '.depo-po-container',
      '.depo-payment-info',
      '.depo-deposit-text',
      '.depo-pp-label',
      '[class*="depo"]',
      '[class*="deposit"]'
    ];

    let totalElementsFound = 0;
    let textUpdated = false;

    selectors.forEach(selector => {
      const elements = document.querySelectorAll(selector);
      totalElementsFound += elements.length;

      elements.forEach(element => {
        // Search for text nodes and update them
        const walker = document.createTreeWalker(
          element,
          NodeFilter.SHOW_TEXT,
          null,
          false
        );

        let node;
        while ((node = walker.nextNode())) {
          if (node.textContent.includes('book seat')) {
            node.textContent = node.textContent.replace(
              'book seat',
              'Reserve Your BAM Trip'
            );
            textUpdated = true;
          }
        }

        // Also check for any elements that might contain the text
        const textElements = element.querySelectorAll('*');
        textElements.forEach(textEl => {
          if (textEl.textContent && textEl.textContent.includes('book seat')) {
            textEl.textContent = textEl.textContent.replace(
              'book seat',
              'Reserve Your BAM Trip'
            );
            textUpdated = true;
          }
        });
      });
    });

    // Also specifically target the depo-pp-label class
    const depoLabels = document.querySelectorAll('.depo-pp-label');

    depoLabels.forEach((label, index) => {
      if (label.textContent && label.textContent.includes('book seat')) {
        label.textContent = label.textContent.replace(
          'book seat',
          'Reserve Your BAM Trip'
        );
        textUpdated = true;
      }
    });
  }

  // Track if dummy button listener has been added
  let dummyButtonListenerAdded = false;

  // Function to find the Depo button using multiple strategies
  function findDepoButton() {
    // Strategy 1: Look for button by ID
    let button = document.getElementById(BUTTON_ID);
    if (button) return button;

    // Strategy 2: Look for button inside Depo containers
    const depoContainers = document.querySelectorAll('.depo-po-container, .depo-payment-info, [class*="depo"]');
    for (const container of depoContainers) {
      const btn = container.querySelector('button');
      if (btn) {
        console.log('[findDepoButton] Found Depo button in container:', container.className);
        return btn;
      }
    }

    // Strategy 3: Look for buttons with Depo-related classes or IDs
    const allButtons = document.querySelectorAll('.product-form__buttons button, #product-form-buttons button');
    for (const btn of allButtons) {
      const btnId = btn.id || '';
      const btnClass = btn.className || '';
      if (btnId.includes('depo') || btnClass.includes('depo')) {
        console.log('[findDepoButton] Found Depo button by class/id:', { id: btnId, class: btnClass });
        return btn;
      }
    }

    return null;
  }

  // Hide real button and show dummy button until form is valid
  function manageButtonVisibility() {
    const realButton = findDepoButton();
    const dummyButton = document.getElementById('dummy-book-now');

    if (!realButton) {
      return false;
    }

    // Set up dummy button click handler if it exists (only once)
    if (dummyButton && !dummyButtonListenerAdded) {
      dummyButton.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopImmediatePropagation();
        if (!validateForm()) {
          showErrorMessage();
        }
      });
      dummyButtonListenerAdded = true;
    }

    // Show/hide buttons based on form validity
    const isFormValid = validateForm();

    if (isFormValid) {
      // Show Depo button (add visible class)
      realButton.classList.add('depo-button-visible');
      realButton.removeAttribute('aria-hidden');

      // Hide validation button when Depo button is shown and remove disabled attribute
      const validationButtons = document.querySelectorAll(
        '.product-form__buttons button.product-form__submit'
      );
      console.log(
        '[formSubmit] Found validation buttons:',
        validationButtons.length
      );
      validationButtons.forEach(button => {
        if (
          button.disabled ||
          button.textContent.includes('Please select all required options')
        ) {
          console.log(
            '[formSubmit] Hiding validation button:',
            button.textContent.trim()
          );
          button.style.display = 'none';
          button.setAttribute('aria-hidden', 'true');
          button.removeAttribute('disabled');
          button.removeAttribute('aria-disabled');
        }
      });
      hideErrorMessage();
    } else {
      // Hide Depo button (remove visible class)
      realButton.classList.remove('depo-button-visible');
      realButton.setAttribute('aria-hidden', 'true');

      // Show validation button when validation fails and add disabled attribute
      const validationButtons = document.querySelectorAll(
        '.product-form__buttons button.product-form__submit'
      );
      validationButtons.forEach(button => {
        if (button.textContent.includes('Please select all required options')) {
          button.style.display = 'block';
          button.removeAttribute('aria-hidden');
          button.setAttribute('disabled', 'true');
          button.setAttribute('aria-disabled', 'true');
        }
      });
    }

    return true;
  }

  // Function to get traveler names
  function getTravelerNames() {
    const travelersWrapper = document.getElementById('travelers-wrapper');
    if (!travelersWrapper) return [];

    const travelerInputs = travelersWrapper.querySelectorAll(
      '.traveler-group input[type="text"]'
    );
    return Array.from(travelerInputs)
      .map(input => input.value.trim())
      .filter(name => name !== '');
  }

  // Function to handle field changes
  function handleFieldChange() {
    manageButtonVisibility();

    // Update URL with current form values
    const locationField = document.querySelector('#boarding_location');
    const timeField = document.querySelector('#boarding_time');
    const qtyField = document.getElementById('CustomQuantityProperty');
    const seatingField = document.querySelector('#seating_preference');

    if (locationField && timeField && qtyField) {
      updateURL(
        locationField.value,
        timeField.value,
        getTravelerNames(),
        qtyField.value,
        seatingField?.value
      );
    }
  }

  // Function to automatically manage traveler inputs based on quantity
  function manageTravelerInputs() {
    const travelersWrapper = document.getElementById('travelers-wrapper');
    if (!travelersWrapper) return;

    const quantity =
      parseInt(document.getElementById('CustomQuantityProperty')?.value) || 0;
    const currentTravelerGroups =
      travelersWrapper.querySelectorAll('.traveler-group');
    const currentCount = currentTravelerGroups.length;

    // Check if inputs should be disabled (product is sold out)
    const boardingLocationSelect = document.getElementById('boarding_location');
    const isDisabled =
      boardingLocationSelect && boardingLocationSelect.disabled;

    console.log(
      '[manageTravelerInputs] Quantity:',
      quantity,
      'Current travelers:',
      currentCount,
      'Inputs disabled:',
      isDisabled
    );

    if (quantity > currentCount) {
      // Add missing traveler groups
      for (let i = currentCount; i < quantity; i++) {
        const newTravelerGroup = document.createElement('div');
        newTravelerGroup.className = 'traveler-group';
        newTravelerGroup.setAttribute('data-index', i + 1);

        const travelerNumber = i + 1;
        const headingText =
          quantity > 1
            ? `Traveler #${travelerNumber} First & Last Name`
            : 'Traveler First & Last Name';

        newTravelerGroup.innerHTML = `
          <h4>${headingText}</h4>
          <div class="input-row">
            <label>
              Name
              <input type="text" name="properties[Traveler ${travelerNumber} Name]" required ${
          isDisabled ? 'disabled' : ''
        }>
            </label>
          </div>
          <button type="button" class="remove-traveler" style="display: none">Remove</button>
        `;

        // Add event listeners to the new input
        const newInput = newTravelerGroup.querySelector('input[type="text"]');
        if (newInput) {
          newInput.addEventListener('change', handleFieldChange);
          newInput.addEventListener('input', handleFieldChange);
        }

        travelersWrapper.appendChild(newTravelerGroup);
      }
    } else if (quantity < currentCount) {
      // Remove excess traveler groups
      for (let i = currentCount - 1; i >= quantity; i--) {
        const groupToRemove = currentTravelerGroups[i];
        if (groupToRemove) {
          groupToRemove.remove();
        }
      }
    }
  }

  // Legacy function for backward compatibility (now just calls manageTravelerInputs)
  function handleAddTraveler() {
    manageTravelerInputs();
  }

  // Function to set up the form
  function setupForm() {
    // Add change handlers to all form fields
    const form = document.querySelector('form[data-type="add-to-cart-form"]');
    if (form) {
      const fields = form.querySelectorAll('select, input[type="text"]');
      fields.forEach(field => {
        field.addEventListener('change', handleFieldChange);
        field.addEventListener('input', handleFieldChange);
      });

      // Add specific listener for quantity input to manage traveler inputs
      const quantityInput = document.querySelector('input[name="quantity"]');
      if (quantityInput) {
        quantityInput.addEventListener('change', function () {
          // Update the hidden custom quantity property
          const customQtyInput = document.getElementById(
            'CustomQuantityProperty'
          );
          if (customQtyInput) {
            customQtyInput.value = this.value;
          }
          // Automatically manage traveler inputs
          manageTravelerInputs();
          // Trigger validation
          handleFieldChange();
        });
        quantityInput.addEventListener('input', function () {
          // Update the hidden custom quantity property
          const customQtyInput = document.getElementById(
            'CustomQuantityProperty'
          );
          if (customQtyInput) {
            customQtyInput.value = this.value;
          }
          // Automatically manage traveler inputs
          manageTravelerInputs();
          // Trigger validation
          handleFieldChange();
        });
      }
    }

    // Check URL parameters and pre-fill fields
    const urlParams = new URLSearchParams(window.location.search);
    const location = urlParams.get('location');
    const time = urlParams.get('time');
    const names = urlParams.get('names')?.split(',') || [];
    const quantity = urlParams.get('quantity');
    const seating = urlParams.get('seating');

    // Set quantity if provided
    if (quantity) {
      const qtyField = document.getElementById('CustomQuantityProperty');
      if (qtyField) {
        qtyField.value = quantity;
        qtyField.dispatchEvent(new Event('change'));
        // Trigger validation after setting quantity
        setTimeout(() => manageButtonVisibility(), 50);
      }
    }

    // Set location if provided
    if (location) {
      const locationField = document.querySelector('#boarding_location');
      if (locationField) {
        locationField.value = location;
        locationField.dispatchEvent(new Event('change'));
        // Trigger validation after setting location
        setTimeout(() => manageButtonVisibility(), 50);
      }
    }

    // Set time if provided (with delay to allow location-dependent times to load)
    if (time) {
      setTimeout(() => {
        const timeField = document.querySelector('#boarding_time');
        if (timeField) {
          timeField.value = time;
          timeField.dispatchEvent(new Event('change'));
          // Trigger validation after setting time
          setTimeout(() => manageButtonVisibility(), 50);
        }
      }, 100);
    }

    // Set seating preference if provided
    if (seating) {
      const seatingField = document.querySelector('#seating_preference');
      if (seatingField) {
        seatingField.value = seating;
        seatingField.dispatchEvent(new Event('change'));
        // Trigger validation after setting seating preference
        setTimeout(() => manageButtonVisibility(), 50);
      }
    }

    // Set traveler names if provided
    if (names.length > 0) {
      const travelersWrapper = document.getElementById('travelers-wrapper');
      if (travelersWrapper) {
        // Check if inputs should be disabled (product is sold out)
        const boardingLocationSelect =
          document.getElementById('boarding_location');
        const isDisabled =
          boardingLocationSelect && boardingLocationSelect.disabled;

        // Clear existing traveler groups
        travelersWrapper.innerHTML = '';

        // Add traveler groups for each name
        names.forEach((name, index) => {
          const newTravelerGroup = document.createElement('div');
          newTravelerGroup.className = 'traveler-group';
          newTravelerGroup.setAttribute('data-index', index + 1);

          const travelerNumber = index + 1;
          const headingText =
            names.length > 1
              ? `Traveler #${travelerNumber} First & Last Name`
              : 'Traveler First & Last Name';

          newTravelerGroup.innerHTML = `
            <h4>${headingText}</h4>
            <div class="input-row">
              <label>
                Name
                <input type="text" name="properties[Traveler ${travelerNumber} Name]" required value="${name}" ${
            isDisabled ? 'disabled' : ''
          }>
              </label>
            </div>
            <button type="button" class="remove-traveler" style="display: none">Remove</button>
          `;

          // Add event listeners to the new input
          const newInput = newTravelerGroup.querySelector('input[type="text"]');
          if (newInput) {
            newInput.addEventListener('change', handleFieldChange);
            newInput.addEventListener('input', handleFieldChange);
          }

          travelersWrapper.appendChild(newTravelerGroup);
        });
        // Trigger validation after setting traveler names
        setTimeout(() => manageButtonVisibility(), 50);
      }
    }

    // Reset to 1 traveler on page load (unless URL parameters specify otherwise)
    if (!names.length) {
      const travelersWrapper = document.getElementById('travelers-wrapper');
      if (travelersWrapper) {
        // Keep only the first traveler group, remove any additional ones
        const travelerGroups =
          travelersWrapper.querySelectorAll('.traveler-group');
        for (let i = 1; i < travelerGroups.length; i++) {
          travelerGroups[i].remove();
        }

        // Reset the first traveler group to default state
        if (travelerGroups[0]) {
          const firstInput =
            travelerGroups[0].querySelector('input[type="text"]');
          if (firstInput) {
            firstInput.value = '';
            firstInput.name = 'properties[Traveler 1 Name]';
          }

          // Update heading to remove number if present
          const heading = travelerGroups[0].querySelector('h4');
          if (heading) {
            heading.textContent = 'Traveler First & Last Name';
          }
        }
      }
    }

    // Initial traveler inputs setup based on current quantity
    manageTravelerInputs();

    // Initial button visibility setup
    manageButtonVisibility();
    handleFieldChange();

    const variantPicker = document.querySelector('variant-radios, variant-selects');
    if (variantPicker && !variantPicker.dataset.bamDepoVariantSync) {
      variantPicker.dataset.bamDepoVariantSync = 'true';
      variantPicker.addEventListener('change', handleFieldChange);
    }

    // Trigger validation after a short delay to ensure all URL parameters are processed
    setTimeout(() => {
      manageButtonVisibility();
    }, 100);

    // Also try validation after longer delays to catch late-loading Depo button
    setTimeout(() => {
      console.log('[setupForm] Running delayed validation after 500ms');
      manageButtonVisibility();
    }, 500);

    setTimeout(() => {
      console.log('[setupForm] Running delayed validation after 1000ms');
      manageButtonVisibility();
    }, 1000);

    setTimeout(() => {
      console.log('[setupForm] Running delayed validation after 2000ms');
      manageButtonVisibility();
    }, 2000);

    // Initial deposit text update in case Depo elements are already present
    updateDepositText();

    // Listen for partial-payment mode changes dispatched by the order-number JS
    // (added in main-product.liquid for hotel stays only)
    document.addEventListener('bam:revalidate-form', function () {
      console.log('[depoUpdater] bam:revalidate-form received — re-running button visibility');
      manageButtonVisibility();
    });

    // Also listen on the order-number input directly (catches mid-edit keystrokes)
    const orderInput = document.getElementById('original-order-number');
    if (orderInput) {
      orderInput.addEventListener('input', function () {
        manageButtonVisibility();
      });
    }
  }

  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setupForm);
  } else {
    setupForm();
  }

  // Also try setup after a short delay to catch any late-loading elements
  setTimeout(setupForm, 100);
  setTimeout(setupForm, 500);

  // Test deposit text update after delays
  setTimeout(function () {
    updateDepositText();
  }, 1000);

  setTimeout(function () {
    console.log(
      '[debug-depo-text] Testing deposit text update after 3 seconds'
    );
    updateDepositText();
  }, 3000);

  // Immediate test to see what elements exist
  setTimeout(function () {
    console.log(
      '[debug-depo-text] IMMEDIATE TEST - Looking for Depo elements...'
    );
    const allDepoElements = document.querySelectorAll('[class*="depo"]');
    console.log(
      '[debug-depo-text] Found',
      allDepoElements.length,
      'elements with "depo" in class name'
    );
    allDepoElements.forEach((el, index) => {
      console.log(
        '[debug-depo-text] Element',
        index,
        ':',
        el.className,
        el.textContent
      );
    });
  }, 100);

  // Watch for Depo button to appear and ensure it stays hidden until validation
  const observer = new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      if (mutation.type === 'childList') {
        // Check if Depo button was just added to the DOM
        mutation.addedNodes.forEach(function (node) {
          if (node.nodeType === Node.ELEMENT_NODE) {
            // Check if this is the Depo button or contains it
            let depoButton = null;
            if (node.id === BUTTON_ID) {
              depoButton = node;
            } else if (node.querySelector) {
              depoButton = node.querySelector('#' + BUTTON_ID) || 
                          node.querySelector('.depo-po-container button') ||
                          node.querySelector('[class*="depo"] button');
            }
            // Also check if the node itself is a button with Depo-related classes
            if (!depoButton && node.tagName === 'BUTTON') {
              const btnId = node.id || '';
              const btnClass = node.className || '';
              if (btnId.includes('depo') || (typeof btnClass === 'string' && btnClass.includes('depo'))) {
                depoButton = node;
              }
            }
            // Check if any Depo container was added
            if (!depoButton) {
              const className = node.className;
              const classNameStr = typeof className === 'string' ? className : (className?.baseVal || String(className || ''));
              if (classNameStr && (classNameStr.includes('depo') || classNameStr.includes('deposit'))) {
                // A Depo container was added, check for button inside
                setTimeout(() => {
                  const foundButton = findDepoButton();
                  if (foundButton) {
                    manageButtonVisibility();
                  }
                }, 100);
              }
            }
            if (depoButton) {
              setTimeout(() => {
                manageButtonVisibility();
              }, 100);
            }
          }
        });

        // Check for Depo button visibility
        const depoButton = findDepoButton();
        if (
          depoButton &&
          depoButton.classList.contains('depo-button-visible')
        ) {
          const isFormValid = validateForm();
          if (!isFormValid) {
            depoButton.classList.remove('depo-button-visible');
            depoButton.setAttribute('aria-hidden', 'true');
          }
        }

        // Check for new Depo elements and update deposit text
        mutation.addedNodes.forEach(function (node) {
          if (node.nodeType === Node.ELEMENT_NODE) {
            // Check if this is a Depo-related element
            // Safely check className - it might not be a string (e.g., SVG elements)
            const className = node.className;
            const classNameStr = typeof className === 'string' ? className : (className?.baseVal || String(className || ''));
            const hasDepoClass = classNameStr && (
              classNameStr.includes('depo') || 
              classNameStr.includes('deposit')
            );
            
            if (
              node.classList &&
              (node.classList.contains('depo-po-container') ||
                node.classList.contains('depo-payment-info') ||
                node.classList.contains('depo-deposit-text') ||
                node.classList.contains('depo-pp-label') ||
                hasDepoClass)
            ) {
              console.log(
                '[debug-depo-text] Found Depo element, updating deposit text'
              );
              updateDepositText();
            }

            // Also check for any Depo elements within the added node
            const depoElements =
              node.querySelectorAll &&
              node.querySelectorAll('[class*="depo"], [class*="deposit"]');
            if (depoElements && depoElements.length > 0) {
              console.log(
                '[debug-depo-text] Found Depo elements within added node, updating deposit text'
              );
              updateDepositText();
            }
          }
        });
      }
    });
  });

  // Start observing
  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
  
  // Also observe the buttons container specifically for more targeted detection
  const buttonsContainerObserver = new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
        console.log('[ButtonsContainerObserver] New nodes added to buttons container');
        mutation.addedNodes.forEach(function (node) {
          if (node.nodeType === Node.ELEMENT_NODE) {
            console.log('[ButtonsContainerObserver] Added node:', {
              tagName: node.tagName,
              id: node.id,
              className: typeof node.className === 'string' ? node.className : String(node.className || ''),
              text: node.textContent?.trim().substring(0, 50)
            });
            // Check if this might be a Depo button
            const depoButton = findDepoButton();
            if (depoButton) {
              console.log('[ButtonsContainerObserver] Depo button found after node addition!');
              setTimeout(() => {
                manageButtonVisibility();
              }, 50);
            }
          }
        });
      }
    });
  });
  
  // Start observing the buttons container when it exists
  const observeButtonsContainer = () => {
    const buttonsContainer = document.querySelector('.product-form__buttons.flex-column, #product-form-buttons');
    if (buttonsContainer) {
      buttonsContainerObserver.observe(buttonsContainer, {
        childList: true,
        subtree: true
      });
      console.log('[ButtonsContainerObserver] Started observing buttons container');
    } else {
      // Try again after a delay
      setTimeout(observeButtonsContainer, 100);
    }
  };
  
  // Start observing buttons container
  observeButtonsContainer();
  
  // Also try after delays to catch late-loading containers
  setTimeout(observeButtonsContainer, 500);
  setTimeout(observeButtonsContainer, 1000);

  // Additional periodic check to ensure Depo button stays hidden and deposit text is updated
  // Also actively search for Depo button if it hasn't been found yet
  let depoButtonFound = false;
  setInterval(function () {
    const depoButton = findDepoButton();
    
    // If we just found the button for the first time, trigger visibility check
    if (depoButton && !depoButtonFound) {
      console.log('[PeriodicCheck] Depo button found for the first time!');
      depoButtonFound = true;
      manageButtonVisibility();
    }
    
    if (depoButton && depoButton.classList.contains('depo-button-visible')) {
      const isFormValid = validateForm();
      if (!isFormValid) {
        depoButton.classList.remove('depo-button-visible');
        depoButton.setAttribute('aria-hidden', 'true');
      }
    }

    // Periodically check for deposit text that might have appeared
    updateDepositText();
  }, 100);
  
  // More aggressive check for Depo button appearance (runs less frequently but more thoroughly)
  let aggressiveCheckCount = 0;
  const aggressiveCheckInterval = setInterval(function () {
    aggressiveCheckCount++;
    const depoButton = findDepoButton();
    
    if (depoButton) {
      console.log('[AggressiveCheck] Depo button found after', aggressiveCheckCount * 500, 'ms');
      clearInterval(aggressiveCheckInterval);
      if (!depoButtonFound) {
        depoButtonFound = true;
        manageButtonVisibility();
      }
    } else if (aggressiveCheckCount >= 40) {
      // Stop after 20 seconds (40 * 500ms)
      console.log('[AggressiveCheck] Stopping aggressive check after 20 seconds');
      clearInterval(aggressiveCheckInterval);
    } else {
      // Log periodically to show we're still looking
      if (aggressiveCheckCount % 10 === 0) {
        console.log('[AggressiveCheck] Still searching for Depo button...', aggressiveCheckCount * 500, 'ms');
      }
    }
  }, 500);
})();
